export const _isShowBirthdayMsg = urlData => {
    const today = new Date();
    let isShowMsg = false;
    const birthdayData = urlData;

    if (Object.keys(birthdayData).length) {
        const startDate = new Date(birthdayData.from_date);
        startDate.setHours(0, 0, 0);
        const endDate = new Date(birthdayData.to_date);
        endDate.setHours(23, 59, 59);

        if (today >= startDate && today <= endDate) {
            isShowMsg = true;
        }
    }
    return isShowMsg;
};
